import React from 'react';

export function Label({ children }: { children: React.ReactNode }) {
    if (!children) {
        return null;
    }
    return (
        <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
            {children}
        </span>
    );
}
